import React, { useEffect } from "react";
import { Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import "./OfferPopupStyle.css";

export default function OfferPopup({ visible, onClose, onContinue }) {
  useEffect(() => {
    // When modal is open, prevent scrolling on the main body
    if (visible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [visible]);

  if (!visible) return null;

  return (
    <div className="custom-modal-overlay" onClick={onClose}>
      <div
        className="custom-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="offer-popup-container">
          <CloseOutlined className="offer-close-icon" onClick={onClose} />
          <div className="offer-header">$24 IN 24 HOURS</div>

          <div>
            <div className="offer-title">
              LIMITED-TIME
              <br />
              INSPECTION DEAL
            </div>

            <div className="offer-description">
              Get your inspection completed within 24 hours for just $24 —{" "}
              <span className="offer-bold ">that's over 20% OFF!</span>
            </div>

            <div className="offer-guarantee">
              Lowest price online — guaranteed!
            </div>

            <div className="offer-urgency">Act fast — offer ends soon!</div>

            <div className="offer-restrictions">
              Restrictions apply. Valid for a single company selection only.
              Adding another company incurs an additional $17.99 charge.
            </div>
          </div>

          <Button className="continue-button" onClick={onContinue}>
            CONTINUE
          </Button>
        </div>
      </div>
    </div>
  );
}
